import React from 'react';

import styled from 'styled-components';

import { Color } from '@assets/constants';

export const TermsAndConditionsPage = () => {
  return (
    <Wrapper>
      <Title>Общи условия за ползване на уебсайта teniskivarna.com</Title>
      <LargeSpacer />
      <Text>
        Използването на този сайт и регистрирането на поръчка чрез него се счита
        за съгласие с настоящите Общи условия. Ако НЕ ПРИЕМАТЕ тези условия,
        моля, не използвайте този уебсайт. &quot;ТЕНИСКИ ВАРНА&quot; ЕООД с ЕИК
        207170625, със седалище и адрес на управление гр. Варна, п.к. 9009, р-н
        Младост, бул. &quot;Сливница&quot; № 185, ет. 0, представлявано от
        Томислав Димитров, си запазва правото да променя условията по всяко
        време, без предварително известие, като променените условия ще бъдат
        своевременно публикувани в сайта.
      </Text>
      <LargeSpacer />
      <BoldText>I. Общи условия</BoldText>
      <Spacer />
      <StyledUl>
        <li>
          <Text>
            www.teniskivarna.com е уебсайт за електронна търговия – за продажба
            и доставка на добавените в него стоки от името на &quot;ТЕНИСКИ
            ВАРНА&quot; ЕООД.
          </Text>
        </li>
        <li>
          <Text>
            &quot;ТЕНИСКИ ВАРНА&quot; ЕООД чрез www.teniskivarna.com има право
            да променя цените на предлаганите стоки по собствена преценка, без
            предварително уведомяване. Потребителят - след получаване на
            потвърждение от търговеца, че договорът е сключен, е длъжен да
            заплати цената, която е била актуална по време на поръчката на
            желаната стока.
          </Text>
        </li>
        <li>
          <Text>
            При посочени грешен адрес, лице за контакти и/или телефонен номер
            при поръчката и/или неполучаване от страна на клиента{' '}
            <BoldText>
              след потвърждение за получаване на поръчката от страна на
              търговеца и направен от представител на търговеца опит за
              установяване на връзка и поправка на данните от страна на клиента,
              &quot;ТЕНИСКИ ВАРНА&quot; ЕООД чрез www.teniskivarna.com не е
              обвързано от задължение за изпълнение на поръчката, а КЛИЕНТЪТ
              дължи сторените разходи за продукта и доставката, ако поръчката е
              вече изпълнена.
            </BoldText>
          </Text>
        </li>
        <li>
          <Text>
            Договорът с Клиента се счита за сключен след приемане от
            &quot;ТЕНИСКИ ВАРНА&quot; ЕООД чрез www.teniskivarna.com на
            заявлението за покупка, попълнено правилно от Клиента по време на
            процеса на поръчка.{' '}
            <BoldText>
              Приемането се удостоверява с получаване на електронно съобщение на
              посочения от клиента електронен адрес.
            </BoldText>
          </Text>
        </li>
        <li>
          <Text>
            &quot;ТЕНИСКИ ВАРНА&quot; ЕООД чрез www.teniskivarna.com се
            задължава, след получаване на заявление от Клиента, да му достави
            желаната стока или да информира Клиента за други обстоятелства
            относно заявката му.
          </Text>
        </li>
        <li>
          <Text>
            &quot;ТЕНИСКИ ВАРНА&quot; ЕООД не носи отговорност, ако Клиентът е
            посочил неверни и/или непълни данни в направена поръчка през
            уебсайта www.teniskivarna.com.
          </Text>
        </li>
        <li>
          <Text>
            Публикуваната на сайта информация за размери и съответствия трябва
            да се тълкува като ориентировъчна. &quot;ТЕНИСКИ ВАРНА&quot; ЕООД
            допуска наличието на разминавания между обявените и действителните
            размери, за което не носи отговорност.
          </Text>
        </li>
        <li>
          <Text>Всички обявени цени са в български левове с включен ДДС.</Text>
        </li>
        <li>
          <BoldText>
            С ползване на услугите на &quot;ТЕНИСКИ ВАРНА&quot; ЕООД, клиентът
            се съгласява да получава информация за настоящите общи условия,
            тяхната промяна, за конкретните параметри по договора с търговеца,
            за плащането и доставката по електронен път.
          </BoldText>
        </li>
      </StyledUl>
      <LargeSpacer />

      <BoldText>II. Права и задължения на страните</BoldText>
      <Spacer />
      <StyledOl>
        <li>
          <Text>&quot;ТЕНИСКИ ВАРНА&quot; ЕООД се задължава:</Text>
          <StyledUl>
            <li>
              <Text>
                да потвърди наличността на поръчаните артикули или да откаже
                поръчката в срок от 4 работни дни{' '}
                <BoldText>
                  по електронен път на посочения от клиента електронен адрес;
                </BoldText>
              </Text>
            </li>
            <li>
              <Text>
                да достави в срока, указан в информацията за доставка и плащане
                на стоки, заявената за покупка стока;
              </Text>
            </li>
            <li>
              <Text>
                И гарантира, че всички продукти са фабрично нови
                (неупотребявани!) и запечатани от производителя.
              </Text>
            </li>
          </StyledUl>
          <Spacer />
        </li>
        <li>
          <Text>Клиентът се задължава:</Text>
          <StyledUl>
            <li>
              <Text>
                да посочи двете си имена, точена адрес и валиден телефон, адрес
                за доставка и имейл;
              </Text>
            </li>
            <li>
              <Text>
                да плати цената на стоката според условията, описани в
                информацията за Доставка и плащане на стоки;
              </Text>
            </li>
            <li>
              <Text>
                да заплати разходите по доставката според условията, описани в
                информацията за Доставка и плащане на стоки;
              </Text>
            </li>
            <li>
              <BoldText>
                да получи поръчаната стока, или да я заплати, ведно с цената за
                доставка, в случай, че същата е индивидуализирана и изготвена по
                негова поръчка, а ако не е индивидуализирана - да заплати
                разходите за доставка на неполучената стока.
              </BoldText>
            </li>
          </StyledUl>
          <Spacer />
        </li>
        <li>
          <Text>
            (1) Поръчаните стоки се доставят на посочения от Клиента адрес за
            доставка, в срока, указан в информацията за Доставка и плащане на
            стоки.
          </Text>
          <Spacer />
          <Text>
            (2) Стоката се доставя подходящо опакована, съобразно вида ѝ и
            транспорта за доставка.
          </Text>
          <Spacer />
          <Text>
            (3) При предава на стоката Клиентът или трето лице подписват
            придружаващите я документи. За трето лице се счита всеки, който не е
            титуляр на поръчката, но се намира на посочения от Клиента адрес и
            приема доставената стока.
          </Text>
          <Spacer />
          <Text>
            (4) В случай, че Клиентът не бъде намерен в срока за изпълнение на
            доставката -{' '}
            <BoldText>
              така, както е посочен в потвърждението на получената поръчка или
              най-късно в 14-дневен срок
            </BoldText>
            , на посочения от Клиента адрес за доставка или не бъде осигурен
            достъп и условия за предаване на стоката в този срок, &quot;ТЕНИСКИ
            ВАРНА&quot; ЕООД се освобождава от задължението си да достави
            поръчаната стока.
          </Text>
          <Spacer />
          <Text>
            (5) Клиентът може да потвърди желанието си да получи стоката и след
            изтичане на срока на доставка, в който не е бил намерен на адреса,
            като поеме всички разходи по доставката. В този случай започва да
            тече нов срок за доставка от момента на потвърждението.
          </Text>
          <Spacer />
        </li>
        <li>
          <Text>
            Клиентът има право да откаже получаването на поръчаната от него
            стока, когато тя му бъде доставена, при едно от следните условия:
          </Text>
          <StyledUl>
            <li>
              <Text>
                доставената стока не съответства на поръчаната от Клиента и това
                може да се установи чрез обикновения ѝ преглед;
              </Text>
            </li>
            <li>
              <Text>
                цената, която Клиентът следва да заплати за{' '}
                <BoldText>освобождаването на стоката от куриера</BoldText>, не
                съответства на дължимата цена;
              </Text>
            </li>
            <li>
              <Text>
                има несъответствие между заявената за покупка и доставената
                стока, което не е било възможно да бъде установено в момента на
                доставката. В този случай Клиентът има право да заяви подмяна на
                размер или артикул, фигуриращ в първоначалната му поръчка, в
                срок не по-дълъг от 14 работни дни от датата на получаване на
                поръчката. Необходимо е пратката да бъде върната на адрес: гр.
                Варна 9000, бул. Сливница 185, Delta Planet Mall, обект на
                &quot;ТЕНИСКИ ВАРНА&quot;,{' '}
                <BoldText>
                  като разходите за връщане на стоката във всеки случай са за
                  сметка на клиента;
                </BoldText>
              </Text>
            </li>
          </StyledUl>
          <Spacer />
        </li>
        <li>
          <BoldText>
            В случай, че потребителят е поръчал стока/и, изработена/и по негова
            поръчка или съобразно неговите индивидуални изисквания, и получената
            стока съответства по размер, изглед и крайна цена на данните,
            изпратени в потвърждението за приемане на поръчката, вкл. и на
            визуализацията на крайния продукт, КЛИЕНТЪТ няма право да откаже
            заплащане, респ. получаване на стоката;
          </BoldText>
        </li>
      </StyledOl>
      <LargeSpacer />

      <BoldText>III. Отговорност</BoldText>
      <Spacer />
      <Text>
        &quot;ТЕНИСКИ ВАРНА&quot; ЕООД чрез www.teniskivarna.com не носи
        отговорност за неизпълнение на задълженията си по този договор при
        настъпване на обстоятелства, които &quot;ТЕНИСКИ ВАРНА&quot; ЕООД чрез
        www.teniskivarna.com не е предвидило и не е било длъжно да предвиди –
        вкл., но не само, случаи на непреодолима сила, случайни събития,
        проблеми в глобалната мрежа на Интернет и в предоставянето на услугите
        извън контрола на &quot;ТЕНИСКИ ВАРНА&quot; ЕООД чрез
        www.teniskivarna.com.
      </Text>
      <LargeSpacer />

      <BoldText>IV. Разрешаване на спорове</BoldText>
      <Spacer />
      <Text>
        Всички спорове между страните се решават в дух на разбирателство и добра
        воля. В случай, че съгласие не бъде постигнато, всички неразрешени
        спорове, породени от договора между страните или отнасящи се до него,
        включително спорове, породени или отнасящи се до неговото тълкуване,
        недействителност, изпълнение или прекратяване, както и спорове за
        попълване на празноти в договора или приспособяването му към
        нововъзникнали обстоятелства, ще бъдат разрешавани от компетентния съд
        по регистрация на &quot;ТЕНИСКИ ВАРНА&quot; ЕООД съобразно българското
        законодателство. Ако не приемате горните Общи условия, моля, не
        използвайте сайта!
      </Text>
    </Wrapper>
  );
};

const StyledOl = styled.ol`
  margin-left: 24px;
`;

const StyledUl = styled.ul`
  margin-left: 24px;
`;

const LargeSpacer = styled.div`
  margin: 24px;
`;

const Spacer = styled.div`
  margin: 8px;
`;

const BoldText = styled.span`
  font-weight: bold;
`;

const Text = styled.p``;

const Title = styled.h1`
  font-size: 1.5rem;
  color: ${Color.DARK_GRAY};
  font-weight: bold;
  text-align: center;
`;

const Wrapper = styled.div`
  padding: 1.5rem;
  color: ${Color.DARK_GRAY};
`;
